<template>
  <div class="ta_c pt20 pb20 mt20 mb20">
    <!-- <img style="width: 100px" src="@/assets/images/icons/search_is_empty.png" alt="" /> -->
    <p class="pt10">暂无数据</p>
  </div>
</template>
<script>
  export default {
    name: "empty-table",
  };
</script>
